T.List = Class(
	/**
	 * @lends {T.List#}
	 */
	{
		__construct: function(par){
			par = par || {};

			this.node = mkE({
				tag: 'div',
				className: 'list',
				els: [
					this._list = mkE({
						tag: 'ul'
					})
				]
			});

			if( par.caption ){
				this._captionNode = mkE({
					tag: 'div',
					className: 'caption'
				}).prepend(this.node);
				mkE.appendTypeElement(this._captionNode, par.caption);
			}

			this._drawItems(par.items || []);
		},

		_drawItems: function(items){
			for( let i = 0, l = items.length; i < l; i++ ){
				let listItem = mkE({
					tag: 'li'
				}).append(this._list);
				mkE.appendTypeElement(listItem, items[i]);
			}
		}
	},
	mkE.Base
);